import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import TaxCalendar from '../components/sections/TaxCalendar';
import GovernmentLinks from '../components/sections/GovernmentLinks';

const Resources = () => {
  return (
    <div className="resources-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <h1 className="page-hero-title">Tax Resources</h1>
          <p className="page-hero-subtitle">
            Important deadlines and useful government portals for your compliance needs
          </p>
        </div>
      </section>

      {/* Tax Calendar */}
      <TaxCalendar />

      {/* Government Links */}
      <GovernmentLinks />

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Need Help With Compliance?</h2>
            <p className="cta-text">
              Let us handle your tax filings while you focus on growing your business
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-white">
                Schedule Consultation
              </Link>
              <a href="tel:+916396550622" className="btn btn-outline-white">
                <Phone size={20} />
                +91-6396550622
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;
